import { OVERLAY } from '../constants';

export const matchMaker = () => {

  LIFE_CYCLE_EVENT_BUS.on('appliance-matchmaker.overlay-viewed', () => {
    const ddoEvent = {
      category: {
        primaryCategory: OVERLAY
      },
      eventInfo: {
        eventName: 'appliance matchmaker'
      }
    };
    digitalData.event = digitalData.event || [];
    digitalData.event.push(ddoEvent);
  });


  LIFE_CYCLE_EVENT_BUS.on('appliance-matchmaker.matches-viewed', ({ output = {} } = {}) => {
    const { products = [] } = output;

    const ddoEvent = {
      category: {
        primaryCategory: OVERLAY
      },
      eventInfo: {
        eventName: 'matchmaker: your matches'
      },
      content: {
        product: products.map((product) => ({
          productInfo: {
            sku: product?.sku
          }
        }))
      }
    };
    digitalData.event = digitalData.event || [];
    digitalData.event.push(ddoEvent);
  });
};
